
import React from 'react'
import { renderRichText } from '../utils'
import {    
    Tile, Link, Icon
  } from '@storaensods/seeds-react'
import './horizontal-tiles.css';

export default  ({ horizontalTile }) => (
    <div className="se-fullheight horizontalTilesWrapper" key={horizontalTile.node.id}>   
        {horizontalTile.node.tileItem &&
             horizontalTile.node.tileItem.map(item => (
               <div key={item.id} className="se-mb-md horizontalTileBox">                                   
               <Tile key={item.id} color={item.color}>     
                 {item.title && (<h3>{item.title}</h3>)}     
                 {item && renderRichText(item.content.json)}
                 {item.linkTitle && (<Link href={item.linkUrl} style={{ marginTop: 'auto' }}>
                    <Icon color="yellow">
                    chevron_right
                    </Icon>
                    <span>{item.linkTitle}</span>
                  </Link>)}
               </Tile>
               </div>
             ))}
    </div>
   )